var _path, _path2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 42,
    viewBox: "0 0 55 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1291 38.9877C52.8686 32.4856 47.1456 27.5783 40.2722 27.5783C33.3988 27.5783 27.6758 32.4856 26.4153 38.9877C26.142 40.391 27.2515 41.6922 28.6792 41.6922H51.8611C53.2929 41.6922 54.3983 40.395 54.125 38.9877H54.1291Z",
    fill: "url(#paint0_linear_1_350)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2722 24.262C44.1426 24.262 47.2802 21.1244 47.2802 17.254C47.2802 13.3836 44.1426 10.246 40.2722 10.246C36.4018 10.246 33.2643 13.3836 33.2643 17.254C33.2643 21.1244 36.4018 24.262 40.2722 24.262Z",
    fill: "url(#paint1_linear_1_350)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9652 38.3024C33.3825 30.1522 26.2072 23.9968 17.5921 23.9968C8.9769 23.9968 1.80167 30.1522 0.218963 38.3024C-0.123686 40.0646 1.26323 41.6922 3.05805 41.6922H32.122C33.9168 41.6922 35.3038 40.0646 34.9611 38.3024H34.9652Z",
    fill: "url(#paint2_linear_1_350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5921 24.4968C25.8336 24.4968 32.7201 30.2942 34.399 38.0311L34.4703 38.3978C34.7508 39.8405 33.6136 41.1922 32.122 41.1922H3.05805C1.56648 41.1922 0.429253 39.8405 0.709771 38.3978L0.709794 38.3977C2.24775 30.478 9.2209 24.4968 17.5921 24.4968Z",
    stroke: "url(#paint3_linear_1_350)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6038 19.6063C24.3245 18.4921 27.2481 13.762 26.134 9.04134C25.0198 4.32065 20.2897 1.397 15.569 2.51119C10.8483 3.62537 7.92465 8.35547 9.03883 13.0762C10.153 17.7969 14.8831 20.7205 19.6038 19.6063Z",
    fill: "url(#paint4_linear_1_350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6473 9.1562C26.6981 13.6081 23.9409 18.0689 19.489 19.1197C15.037 20.1704 10.5762 17.4132 9.52546 12.9613C8.47471 8.50937 11.2319 4.04857 15.6838 2.99782C20.1358 1.94706 24.5966 4.70427 25.6473 9.1562Z",
    stroke: "url(#paint5_linear_1_350)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_350",
    x: -17.8333,
    y: 5.99678,
    width: 70.8467,
    height: 53.6954,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_350",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1_350",
    x: -9.198,
    y: -15.7256,
    width: 53.5688,
    height: 53.5688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_350",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_350",
    x1: 40.2722,
    y1: 49.4589,
    x2: 40.2722,
    y2: 21.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_350",
    x1: 40.2732,
    y1: 31.9748,
    x2: 40.2732,
    y2: 4.59778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_350",
    x1: 2.13398,
    y1: 40.6932,
    x2: 14.8082,
    y2: 15.7345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_350",
    x1: 2.62647,
    y1: 25.3885,
    x2: 14.1163,
    y2: 49.5813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_350",
    x1: 11.7936,
    y1: 20.4308,
    x2: 23.3792,
    y2: 1.68668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_350",
    x1: 8.54548,
    y1: 5.58828,
    x2: 26.4416,
    y2: 17.4948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService2);
export default __webpack_public_path__ + "static/media/service2.1289ba558026924fce9b83880534efb7.svg";
export { ForwardRef as ReactComponent };